import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { share, type Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { SupplierManagementHelperService } from '../../../core/services/supplier-management-helper.service';
import {
  getFormData,
  serialize,
} from '../../../shared/helpers/utilities.helper';
import type { DeleteParameters } from '../../../shared/models/delete-parameters.models';
// eslint-disable-next-line unicorn/prevent-abbreviations -- TODO: delete the comment and fix the error
import type { IRequestParams } from '../../../shared/models/request-parameters.models';
import type { ApiResponse } from '../../../shared/models/response';
import type { Company } from '../../accounts/models/account.models';
import type { CompaniesCollectionApiResponseDto } from '../models/companies.dto.models';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  readonly #http = inject(HttpClient);
  readonly #supplierManagementHelper = inject(SupplierManagementHelperService);

  getCompany(config: { id: number }): Observable<ApiResponse> {
    return this.#http
      .get<ApiResponse>(`${environment.api.endpoint}/company/${config.id}`)
      .pipe(share());
  }

  createCompany(companyData: Company): Observable<ApiResponse> {
    const formData = getFormData(companyData);
    return this.#http.post<ApiResponse>(
      `${environment.api.endpoint}/company`,
      formData,
    );
  }

  updateCompany(companyData: Company): Observable<ApiResponse> {
    const formData = getFormData(companyData);
    return this.#http.post<ApiResponse>(
      `${environment.api.endpoint}/company/${companyData.id}`,
      formData,
    );
  }

  getFilteredCompanies(
    config: IRequestParams,
  ): Observable<CompaniesCollectionApiResponseDto> {
    const queryString =
      this.#supplierManagementHelper.getFilterAsQuerystring(config);

    return this.#http.get<CompaniesCollectionApiResponseDto>(
      `${environment.api.endpoint}/companies?${queryString}`,
    );
  }

  deleteCompany(deleteParameters: DeleteParameters): Observable<ApiResponse> {
    const queryString = serialize({ type: 'hard' });
    return this.#http.delete<ApiResponse>(
      `${environment.api.endpoint}/company/${deleteParameters.id}?${queryString}`,
    );
  }
}
